import { Link } from "react-router-dom";

import { useEffect } from "react";
import { Helmet } from "react-helmet";

function Contactus() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Helmet>
        <title>Contact Taskflier - Get in Touch with Our Expert Team Today </title>
        
      </Helmet>

        <div class="fancy-feature-twentyNine lg-container bg-white  pt-40 " id="p-tour">
          <div class="container">
            <div class="block-style-thirty bottom-border pb-80">
              <div class="row">
                <div class="col-xl-5 col-lg-6">
                  <div class="text-block md-pb-60">
                    <div class="feature">Contact Us</div>
                    <div class="title-style-nine mb-60 md-mb-40">
                      <h2 className="font-30">Feel free to contact us or just say hi!</h2>
                    </div>
                    <ul class="feature-list-one">
                      <li className="mb-3">
                        <img src="/main/images/india.webp" alt="" class="icon country" />
                        <strong>Head Office</strong>
                        <span className="font-16">A - 1612 Tower 3, NX One Techzone 4 Greater Noida, Uttar Pradesh 201308, India</span>
                     <span className="font-16">
                          <Link to="tel:+919520053030" class="mobile-num">
                            +91 95-2005-3030
                          </Link>
                        </span>
                      </li>
                     

                      <li className="mb-3">
                        <img src="/main/images/uae.webp" alt="" class="icon country" />
                        <strong>Sales Office</strong>
                        <span className="font-16">FDBC2838, Compass Building, Al Shohada Road, Ras Al Khaimah, United Arab Emirates
</span>
<span className="font-16">
                          <Link to="https://wa.me/971553669427?text=I'm interested in Taskflier Project Management" class="mobile-num">
                            
                            +971 55 366 9427
                          </Link>
                        </span>
                      </li>
                      <li className="mb-3">
                        <img src="images/icon/159.svg" alt="" class="icon" />
                        <strong>Connect us</strong>
                        
                        <span className="font-16">
                          <Link to="mailto:support@taskflier.com">support@taskflier.com</Link>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="col-xl-7 col-lg-6">
                  <div class="row align-items-start justify-content-between">
                    <div class="col-md-12 order-lg-last pt-30 ">
                      <div class="req-bg" style={{ background: "#f0f6fc" }}>
                        <p class="text-center text-black fs-16 fw-500 mb-3">For any enquiry, please contact</p>
                        <form class="submitrequest">
                          <div class="messages"></div>
                          <div class="row controls">
                            <div class="col-6">
                              <div class="input-group-meta form-group mb-15">
                                <label>Name</label>
                                <input type="text" placeholder="Your First Name" name="firstName" id="lastname" data-error="Name is required." value="" />
                                <p class="text-danger small text-center"></p>
                              </div>
                            </div>
                            <div class="col-6">
                              <div class="input-group-meta form-group mb-15">
                                <label>Email</label>
                                <input type="text" placeholder="Your Email id" name="lastName" id="lastname" data-error="Name is required." value="" />
                                <p class="text-danger small text-center"></p>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="input-group-meta  form-group mb-15">
                                <label>Mobile No</label>
                                <input type="text" placeholder="Mobile No" name="email" id="email" data-error="Valid email is required." value="" />
                                <p class="text-danger small text-center"></p>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="input-group-meta form-group mb-15">
                                <label>Subject*</label>
                                <input type="number" placeholder="enter subject" name="mobile" id="phone" data-error="Valid phone no. is required." value="" />
                                <p class="text-danger small text-center"></p>
                              </div>
                            </div>

                            <div class="col-12">
                              <div class="input-group-meta form-group mb-2">
                                <label>Your Message</label>
                                <textarea placeholder="Write your message here..." className="heightmessage" name="message" required="" data-error="Please,leave us a message."></textarea>
                                <p class="text-danger small text-center"></p>
                              </div>
                            </div>

                            <p class="fs-12 privacy">
                              When you submit this form, you are consenting to the handling of your personal information in accordance with our{" "}
                              <a class="text-primary" href="/Privacy">
                                Privacy Policy
                              </a>
                              .
                            </p>
                            <div class="col-12">
                              <button type="submit" class="theme-btn-seven w-100 themebutton">
                                Send Message
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-30" hidden>
              <div class="row justify-content-between">
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up">
                  <div class="block-style-thirtyOne mt-20">
                    <div class="icon d-flex align-items-end mb-10">
                      <img src="/images/icon/163.svg" alt="" />
                    </div>

                    <p>Are you interested in a demonstration or do you have inquiries regarding our products and pricing?</p>
                    
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="100">
                  <div class="block-style-thirtyOne mt-20">
                    <div class="icon d-flex align-items-end mb-10">
                      <img src="/images/icon/164.svg" alt="" />
                    </div>

                    <p>Do you require assistance with adding licenses, modifying plans, or incorporating additional services?</p>
                    
                  </div>
                </div>
                <div class="col-lg-4 col-md-6 aos-init" data-aos="fade-up" data-aos-delay="200">
                  <div class="block-style-thirtyOne mt-20">
                    <div class="icon d-flex align-items-end mb-10">
                      <img src="/images/icon/165.svg" alt="" />
                    </div>

                    <p>If you wish to cancel or downgrade your subscription, we regret to see you leave but are here to assist you.</p>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default Contactus;
